<template>
  <a-card :bordered="false">
    <a-row>
      <a-col class="recommend-rules" :span="24">
        <a-row type="flex" justify="space-between">
          <h3>
            <a-icon type="setting"></a-icon>
            当前推荐规则
          </h3>
        </a-row>
        <a-row type="flex" :gutter="66">
          <a-col
            >占比：<span class="recommend-rules-value">{{ settingForm.trialGameRatio | formatText }}%</span></a-col
          >
          <a-col
            >保留正式：<span class="recommend-rules-value">{{ settingForm.minOfficialGames | formatText }}个</span></a-col
          >
          <a-col
            >间隔：<span class="recommend-rules-value">{{ settingForm.minIntervalLessons | formatText }}课时</span></a-col
          >
          <!-- <a-col>每课时体验数：<span class="recommend-rules-value">{{ settingForm.trialGameRatio }}</span></a-col> -->
        </a-row>
      </a-col>
      <a-col :span="24" class="table-title">体验游戏列表</a-col>
      <a-col :span="24">
        <a-table
          :columns="columns"
          rowKey="id"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
        >
          <div slot="abilityTypeName" slot-scope="text">
            <div class="self_td" v-for="item in text.abilitys" :key="item.id">
              {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
              {{ item.secondAbilityName }}
            </div>
          </div>
          <div slot="scoreSetting" slot-scope="text" class="table-ability">
            <div v-for="(item, index) in text.abilitys" :key="index">
              <a-switch @change="setingTypeChange($event, text, item)" :checked="isContentAbilitys(text, item)" checked-children="启用" un-checked-children="禁用" />
            </div>
          </div>
          <div slot="carryNumber" slot-scope="text">
            <a-input-number @blur="tableInputBlurExecutionsNumber(text)" v-model="text.contentConfig[0].executionsNumber" :min="1" :max="99999" class="table-input" />
          </div>
        </a-table>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { CourseResource } from '../../../../utils/http'
import $Bus from '@/pages/projectImpl/js/eventBus'

const columns = [
  {
    title: '游戏名称',
    dataIndex: 'contentName',
  },
  {
    title: '版本',
    dataIndex: 'version',
  },
  {
    title: '能力维度',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  {
    title: '算分设置',
    scopedSlots: { customRender: 'scoreSetting' },
  },
  {
    title: '执行次数',
    width: 100,
    scopedSlots: { customRender: 'carryNumber' },
  },
]

export default {
  name: 'RecommendPage',
  filters: {
    formatText(val) {
      if (val === '' || val === null || val === undefined) {
        return '-'
      }
      return val
    },
  },
  computed: {
    isContentAbilitys() {
      return (record, ability) => {
        const contentAbilityIds = record.contentConfig.map((v) => v.contentAbilityIds).flat(2)

        return contentAbilityIds.includes(ability.id)
      }
    },
  },
  data() {
    return {
      columns: Object.freeze(columns),
      tableRelevant: tableRelevant.call(this),
      settingForm: {},
    }
  },
  created() {
    this.getPageList(true)
    this.getRule()
  },
  methods: {
    async tableInputBlurExecutionsNumber(record) {
      const executionsNumber = record.contentConfig[0]?.executionsNumber
      if (!/(^[1-9]\d*$)/.test(executionsNumber)) {
        this.$message.destroy()
        this.$message.error('请输入正整数')
        return
      }
      this.tableRelevant.tableLoading = true
      const contentAbilityIds = record.contentConfig.map((v) => v.contentAbilityIds).flat(2)
      const Params = {
        id: record.contentConfig[0].id,
        contentAbilityIds: contentAbilityIds,
        executionsNumber: executionsNumber,
      }
      await this.$http.CourseResource.updateCourseExperience(Params)
      this.getPageList(1)
      this.$message.success('操作成功')
    },
    async setingTypeChange(e, record, ability) {
      const contentAbilityIds = record.contentConfig.map((v) => v.contentAbilityIds).flat(2)
      const Params = {
        id: record.contentConfig[0].id,
        contentAbilityIds: e ? contentAbilityIds.concat(ability.id) : contentAbilityIds.filter((v) => v != ability.id),
        executionsNumber: record.contentConfig[0]?.executionsNumber,
      }
      await this.$http.CourseResource.updateCourseExperience(Params)
      this.getPageList(1)
      this.$message.success('操作成功')
    },
    async getRule() {
      const courseInfo = this.$store.getters['course/getCourseInfo']()
      this.settingForm = courseInfo.recommendRule || {}
    },
    async getPageList(reset) {
      this.tableRelevant.tableLoading = true
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }

      const courseInfo = this.$store.getters['course/getCourseInfo']()

      const params = {
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        courseId: courseInfo.id,
      }

      const { data } = await CourseResource.getExperienceList(params).finally(() => {
        this.tableRelevant.tableLoading = false
      })
      this.tableRelevant.tableDataSource = data.items
      this.tableRelevant.tablePagination.total = data.totalCount
    },
  },
}
</script>
<style scoped lang="less">
.recommend-rules {
  padding: 12px;
  background-color: #f1f2f59d;
  border-radius: 6px;
  margin: 16px 0;
  .recommend-rules-value {
    color: #000;
    font-family: 600;
  }
}
.table-title {
  font-family: 600;
  color: #000;
  margin-bottom: 12px;
  margin-top: 24px;
  font-size: 16px;
}
.table-ability div:not(:last-child) {
  padding-bottom: 12px;
}
.table-input /deep/ .ant-input-number-handler-wrap {
  display: none;
}

.table-input {
  width: 100%;
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
}
</style>
